export default (d, s, id, jsSrc, cb, onError) => {
  const element = d.getElementsByTagName(s)[0];
  const fjs = element;
  let js = element;
  js = d.createElement(s);
  js.id = id;
  js.src = jsSrc;
  js.defer = true;
  js.async = true;
  if (fjs && fjs.parentNode) {
    fjs.parentNode.insertBefore(js, fjs);
  } else {
    d.head.appendChild(js);
  }
  js.onerror = onError;
  js.onload = cb;
  js.onreadystatechange = "if (this.readyState === 'complete') this.onload()";
};
